// extracted by mini-css-extract-plugin
export default {"container":"Payments_container__IGf6R","subContainer":"Payments_subContainer__oZUri","leftArrow":"Payments_leftArrow__d9w41","cardsContainer":"Payments_cardsContainer__KL64J"};